// extracted by mini-css-extract-plugin
export default {"container":"HubBadge_container__M3BkK"};